import React, { Component } from 'react';
import './Faqs.scss';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import FaqForm from '../FaqForm';
import FaqsRepeater from './FaqsRepeater';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Search from '../Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';

import { toast } from 'react-toastify';
import { getUrlExtension } from '../../helpers/CommonHelpers';

import download from 'downloadjs';

class Faqs extends Component {
  state = {
    showOverlay: false,
  };
  onClick = (data) => {
    if (data.includes('.mp4')) {
      toast.success(
        `Your download of ${data?.split('.com/')[1]?.split('.')[0]} has started, It may take some time.`,
        { autoClose: 12000, position: 'top-center' }
      );
    }
    download(data);
  };
  render() {
    const {
      faqs,
      onSaveFaq,
      onSearch,
      setFndFormData,
      clearFndFormData,
      onDeleteFaq,
      search,
      user,
      hideActions,
    } = this.props;
    const { showOverlay } = this.state;
    const role = user.roles[0].role.name;
    const hideAddFaqButton =
      role === 'Home Owner' || role === 'Strata Manager' || role === 'Realtor';
    return (
      <div className="faqs">
        <Actions compact>
          <Search
            size="small"
            placeholder="Search FAQs..."
            onChange={onSearch}
          />
          {hideAddFaqButton ? null : (
            <Button
              color="teal"
              label="Add Faq"
              onClick={() => this.setState({ showOverlay: true })}
              icon={<Icon glyph="edit" weight="light" size="small" />}
              size="small"
            />
          )}
        </Actions>
        {faqs.length > 0 ? (
          <>
            <FaqsRepeater
              onEdit={(faq) => {
                setFndFormData(faq);
                this.setState({ showOverlay: true });
              }}
              hideActions={hideActions}
              user={user}
              onDelete={(faq) =>
                window.confirm(
                  `Are you sure you want to delete ${faq.question}?`
                ) && onDeleteFaq(faq)
              }
              faqs={faqs}
              onClick={this.onClick}
              onImageClicked={(x, image) =>
                getUrlExtension(image) === 'heic'
                  ? null
                  : this.onImageClicked(x, image)
              }
            />
          </>
        ) : (
          <Empty
            headline="No FAQs yet"
            strapline="You can use the Faqs section to post any status updates or general comments to keep everyone on the same page."
            searchIsActive={search && search.faqs ? search.faqs : ''}
            cta={
              hideAddFaqButton ? null : (
                <Button
                  color="teal"
                  label="Add Faq"
                  onClick={() => this.setState({ showOverlay: true })}
                  icon={<Icon glyph="edit" weight="light" size="small" />}
                  size="small"
                />
              )
            }
            image={<img alt="No FAQs yet" src="/assets/empty/notes.svg" />}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <FaqForm
              onSaveFaq={onSaveFaq}
              onClose={() =>
                this.setState({ showOverlay: false }, () => {
                  clearFndFormData();
                })
              }
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  search: selectSearch(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFndFormData,
      clearFndFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Faqs);
